import { Col, Modal, Row } from 'antd';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import useThemes from 'hooks/useThemes';
import { platformStates } from 'redux/platformSlice';
import CloseIcon from 'assets/icons/CloseIcon';

interface WithdrawGuideProps {
  isShow: boolean;
  onCancel?: () => void;
  redirectToSwap?: () => void;
}

const WithdrawGuide: React.FunctionComponent<WithdrawGuideProps> = ({
  isShow,
  onCancel,
  redirectToSwap,
}) => {
  const { currentTheme } = useThemes();
  const { isPhone } = useAppSelector(platformStates);
  const t = useAppTranslation();

  return (
    <Modal
      className="common-modal deposit-modal"
      title={t('withdraw-guide.title')}
      visible={isShow}
      onCancel={onCancel}
      footer={null}
      centered
      maskClosable={false}
      closeIcon={<CloseIcon isDarkMode={currentTheme === 'dark'} width="20" height="20" />}
      width={450}
      zIndex={1100}
    >
      <div className={`center-content-col gap-3 ${isPhone ? 'px-10' : 'px-50'}`}>
        <div className="w-full flex justify-center items-center gap-3">
          <div className="relative w-full mfa__modal">
            <Row gutter={[8, 8]} className="mfa__modal-row">
              <Col span={2}>
                <div className="mfa__modal-step">1</div>
              </Col>
              <Col span={22} className="mfa__modal-content">
                <span>{t('withdraw-guide.first-row')}</span>
              </Col>
            </Row>
            <Row gutter={[8, 8]} className="mfa__modal-row">
              <Col span={2}>
                <div className="mfa__modal-step">2</div>
              </Col>
              <Col span={22} className="mfa__modal-content">
                <span>{t('withdraw-guide.second-row')}</span>
              </Col>
            </Row>
            <Row gutter={[8, 8]} className="mfa__modal-row">
              <Col span={2}>
                <div className="mfa__modal-step">3</div>
              </Col>
              <Col span={22} className="mfa__modal-content">
                <span>{t('withdraw-guide.third-row')}</span>
              </Col>
            </Row>
            <Row className="mfa__modal-row">
              <Col span={24} className="mfa__modal-content flex-row items-center justify-center">
                <button className="submit-btn" onClick={redirectToSwap}>
                  {t('go-to-swap')}
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WithdrawGuide;
